import { $BASE_URL } from "src/constants";
import { apiSlice } from './apiSlice';

const apiUrl = `${$BASE_URL}/api/v1/bank`;

export const bankApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getBanks: builder.query({
            query: () => ({
                url: apiUrl,
                // method: 'GET',
                // params: { ...params},
            }),
            transformResponse: (response, meta, arg) => response?.body,
        }),
    }),
});

export const {
    useGetBanksQuery
} = bankApi;
